import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  bottom: 0;
  left: 50%;
  right: 0;
  transform: translate(-50%, -50%);

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 30vw;
  height: 40vh;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.75);

  @media (max-width: 768px) {
    top: 5%;
    bottom: unset;
    left: 0;
    right: 0;
    transform: none;
    width: 80vw;
    margin: auto;
    height: auto;
    padding: 1rem;
  }
`;
export const Title = styled.h1`
  color: #f1f1f1;
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
`;
export const Button = styled.button`
  height: 50px;
  width: 120px;
  border-radius: 10px;
  background-color: #000;
  color: #f1f1f1;
  font-weight: 500;
  font-size: 20px;
  cursor: pointer;
`;

export const Users = styled.div`
`;
export const OneUser = styled.div``;
export const Pic = styled.div``;
export const Name = styled.span``;
export const FollowButton = styled.button``;
export const Username = styled.span``;
